<div class="mainWrapper">
  <div class="headerWrapper"></div>
  <div class="contentWrapper">
    <div class="imgWrapper">
      <img [src]="package?.type === 'Growth' 
      ? '../assets/images/subscriptionFlow/growth-inner-icon.png' 
      : '../assets/images/subscriptionFlow/starter-inner-icon.png'" />
    </div>
    <h2>{{ 'You have successfully subscribed to Package' | translate }}</h2>
    <span>🎉</span>
    <p>{{ package?.name }} - {{ package?.type }} - {{ package?.period }} Plan</p>
    <button [routerLink]="['/site-type']" class="stacksBtn blue">{{ 'Start Now' | translate }}</button>
  </div>
</div>

<div id="middleContainerWrapper" *ngIf="package?.name == 'LTD'">
  <img src="assets/images/payment_success.png" alt="" />
  <h1>{{ 'You have successfully purchased our' | translate }} <span class="premiumDetails">{{ 'Lifetime Offer' | translate }}</span>🎉</h1>
  <button [routerLink]="['/site-type']" class="stacksBtn blue">{{ 'Back to builder' | translate }}</button>
</div>
